import Button, { ButtonProps } from '@anm/components/buttons/Button';
import { FC } from 'react';
import styled from 'styled-components';

export type PlanButtonProps = Partial<ButtonProps> & {
  planName: string;
  periodName: string;
  isSamePlan: boolean;
  isSamePeriod: boolean;
  siblingName?: string | number;
};

const ButtonWrapper = styled(Button)`
  min-width: 180px;
  margin-top: 20px;
`;

const CurrentPlan: FC = () => (
  <ButtonWrapper size="upper-medium" variant="gray" disabled>
    Your current plan
  </ButtonWrapper>
);

const BlueButton: FC<Partial<ButtonProps>> = props => (
  <ButtonWrapper size="upper-medium" variant="light-blue" {...props} />
);

const GetPlan: FC<PlanButtonProps> = ({ planName, siblingName, ...other }) => (
  <BlueButton {...other}>
    Get {planName} {siblingName}
  </BlueButton>
);

const SwitchPlan: FC<PlanButtonProps> = ({ periodName, ...other }) => (
  <BlueButton {...other}>Switch to {periodName}</BlueButton>
);

const PlanButton: FC<PlanButtonProps> = props => {
  const { isSamePlan, isSamePeriod } = props;

  switch (true) {
    case isSamePlan && isSamePeriod:
      return <CurrentPlan />;

    case isSamePlan && !isSamePeriod:
      return <SwitchPlan {...props} />;

    default:
      return <GetPlan {...props} />;
  }
};

export default PlanButton;
